export default {
    showSubfolders  : false,
    filters         : null,     // {'email': 'qwe', ...} - fieldId:value
    sortBy          : null,     // {fieldId: 'name', direction: 'asc'}
    groupsCollapsed : {},       // {groupById: [groupValue, ...], ...}
    groupBy         : {},       // {fieldId: 'name', direction: 'asc'}

    // array of field objects
    // {
    //     "width"         : 275,
    //     "renderMethod"  : "renderView",
    //     "fieldId"       : "name",
    //     "alignment"     : "left",
    //     "type"          : "field"
    // }
    columns         : null,

    panelPosition   : 'left',
};